<bp-property-metadata-views-section
	heading="Portal"
	[entity]="entity"
	[metadata]="metadata"
	[sectionScheme]="sectionScheme"
>
</bp-property-metadata-views-section>
